module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_jewel_7ff2967fed42143d741d22d3a011aae4.png";